/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_Feature_1Inputs */

const et_plan_website_feature_1 = /** @type {(inputs: Plan_Website_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saad selge ja usaldusväärse veebilehe oma ettevõttele`)
};

const en_plan_website_feature_1 = /** @type {(inputs: Plan_Website_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a clear and trustworthy website for your business`)
};

/**
* | output |
* | --- |
* | "Get a clear and trustworthy website for your business" |
*
* @param {Plan_Website_Feature_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_feature_1 = /** @type {((inputs?: Plan_Website_Feature_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_Feature_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_feature_1(inputs)
	return en_plan_website_feature_1(inputs)
});